// extracted by mini-css-extract-plugin
module.exports = {"trophies__container":"Trophies_trophies__container__Ryd_K"};